import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../API";


export const generateMetaAds = createAsyncThunk(
    "generateMetaAds/generateMetaAds",
    async (data) => {
        return apiCall("/business/metasitemap" , "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {

                        return {
                            ...response.data,
                        }
                    } else {
                        // console.log("response error", response.data.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);



